import { render } from "./DeleteCoverage.vue?vue&type=template&id=199e2062"
import script from "./DeleteCoverage.vue?vue&type=script&lang=js"
export * from "./DeleteCoverage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__